import styled from 'styled-components';

const GoogleMapWrap = styled.div`
  height: 350px;
  width: 100%;
`;

// eslint-disable-next-line
export { GoogleMapWrap };
